export { THE_DOCUMENT } from './the-document';
